import { render, staticRenderFns } from "./directionalExam.vue?vue&type=template&id=7b8993a2&scoped=true&"
import script from "./directionalExam.vue?vue&type=script&lang=js&"
export * from "./directionalExam.vue?vue&type=script&lang=js&"
import style0 from "./directionalExam.vue?vue&type=style&index=0&id=7b8993a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8993a2",
  null
  
)

export default component.exports